import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { WebFramework, encrypt, getDomain } from "../../Utilities/utils";
import { POLICY_HIGHLIGHT_PAGE_ROUTE } from "../routes";
import searchProducts from "./Helpers/searchProducts";
import Axios from "axios";
import { POLICY_HIGHLIGHT_ENDPOINT } from "../apiConfig";

function useProductListingPage() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { response } = state;
  console.log("response", response);
  const originalProductList = response?.responses ?? [];
  const [productList, setProductList] = useState(originalProductList);
  const [loading, setLoading] = useState(false);
  console.log("productList", productList);

  const handleOnBack = () => {
    navigate(-1);
  };
  // TODO: Write code for these functions
  const handleSearch = (event) => {
    const searchTerm = event.target.value.toLowerCase().trim();

    if (searchTerm === "") {
      // If search term is empty, reset the product data to the original list
      setProductList(originalProductList);
      return;
    }

    const filteredData = searchProducts(originalProductList, searchTerm);
    console.log("filtered data", filteredData);
    setProductList(filteredData);
  };

  const handleSortByPremium = (val) => {
    console.log("sss", val);
    // if (val === "LOW") {
    //   let filterData = data.sort((a, b) => {
    //     return parseFloat(a.premium) - parseFloat(b.premium);
    //   });
    //   setProductData(filterData);
    //   console.log("low sort", filterData);
    // } else {
    //   let filterData = data.sort((a, b) => {
    //     return parseFloat(b.premium) - parseFloat(a.premium);
    //   });
    //   setProductData(filterData);
    // }
  };

  const handleSort = () => {
    // console.log("sort");
    // setDialogState(true);
  };

  const handleCloseSort = () => {
    // setDialogState(false);
  };

  const handleOnBuy = async (index) => {
    setLoading(true);
    const selectedProduct = productList[index];
    const { product_ref, Acuvisor_product_id, product_id } = selectedProduct;

    let encryptedAcuvisorProductId = encrypt(Acuvisor_product_id);
    console.log("encryptedAcuvisorProductId: ", encryptedAcuvisorProductId);
    let encryptedProductRef = encrypt(product_ref);
    console.log("encryptedProductRef: ", encryptedProductRef);

    const domain = getDomain(WebFramework.DJANGO);

    try {
      // Get policy details
      const res = await Axios.get(
        `${domain}${POLICY_HIGHLIGHT_ENDPOINT}/${response.response_id}/${product_id}/`
      );

      console.log("POLICY HIGHLIGHT PAGE Response", res);
      const encryptedTransferDataId = encrypt(res.data.transferDataId);
      const path = `${POLICY_HIGHLIGHT_PAGE_ROUTE}/${encodeURIComponent(
        encryptedProductRef
      )}/${encodeURIComponent(encryptedTransferDataId)}/${encodeURIComponent(
        encryptedAcuvisorProductId
      )}/`;
      navigate(path, {
        state: {
          response: res.data,
        },
      });
    } catch (error) {
      console.log("error: ", error);
      setLoading(false);
      alert("Something went wrong, try again..");
    }
  };

  return {
    productList,
    handleOnBack,
    handleSearch,
    handleSort,
    handleCloseSort,
    handleSortByPremium,
    handleOnBuy,
    loading,
  };
}

export default useProductListingPage;
